export default __webpack_public_path__ + "static/media/TMDBLogoLight.0299349b.svg";